import { Box, Button, Card, Input } from "@nimbus-ds/components";
import { FormField } from "@nimbus-ds/patterns";
import { useNavigate } from "react-router-dom";

const CustomCredentials = ({ storeInfo }: { storeInfo: any }) => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate("/");
  };

  return (
    <div className="custom-credentials-container">
      <Box flex="1" maxWidth="500px">
        <Card>
          <Card.Header title="Gestionar Mis Credenciales" />
          <Card.Body>
            <Box display="flex" flexDirection="column" gap="4">
              {/* <Text>
                ¿No tenés una cuenta?
                <Link appearance="primary" textDecoration="none">
                  Creá acá una
                </Link>
              </Text> */}
              {/* <Alert appearance="danger" title="Mensaje de error">
              Texto del error
            </Alert> */}
              <Box display="flex" flexDirection="column" gap="2">
                <FormField label="Email">
                  <Input />
                </FormField>
                <FormField label="Password">
                  <Input.Password />
                </FormField>
                <FormField label="Confirmar Password">
                  <Input.Password />
                </FormField>
                {/* <Link appearance="primary">¿Olvidaste tu contraseña?</Link> */}
              </Box>
              {/* <Checkbox label="Mantenerme conectado" name="keep-login" /> */}
            </Box>
          </Card.Body>
          <Card.Footer>
            <Button appearance="primary">Guardar</Button>
            <Button appearance="neutral" onClick={handleGoBack}>
              Volver
            </Button>
          </Card.Footer>
        </Card>
      </Box>
    </div>
  );
};

export default CustomCredentials;
